import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './AuthContext';
import Login from './Login';
import Register from './Register';
import './aws-config';

const AuthWrapper = ({ children }) => {
  const { user, loading, login } = useAuth();
  const [showRegister, setShowRegister] = React.useState(false);

  if (loading) {
    return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  }

  if (!user) {
    return showRegister ?
      <Register switchToLogin={() => setShowRegister(false)} /> :
      <Login onLogin={login} switchToRegister={() => setShowRegister(true)} />;
  }

  return children;
};

export default AuthWrapper;
